<template>
    <a :href="'tel:+' + plainValue" v-html="value"></a>
</template>

<script>
    export default {
        name: 'VPhone',

        props: {
            value: {
                type: String,
                required: true,
            },
        },

        computed: {
            plainValue () {
                return this.value.replace(/\D+/g, '');
            }
        }
    }
</script>